import React, {FC} from 'react';
import {useSelector} from 'react-redux';
import {WeatherHistoricValues} from '@/app/interfaces/weather';
import {temperatureDisplayReduce} from '@/common/helpers/unitReducers/temperatureDisplayReduce';
import {useLocalizer} from '@/common/services/localizer';
import {selectTemperatureUnit} from '@/app/store/config/selectors';
import styles from './WeatherHistoric.css';

interface WeatherDailyHistoricProps {
	className?: string;
	date: string;
	historic: WeatherHistoricValues;
	locationTimezone: string;
}

export const WeatherHistoric: FC<WeatherDailyHistoricProps> = props => {
	const {className, date, locationTimezone, historic} = props;

	const temperatureUnit = useSelector(selectTemperatureUnit);

	const t = useLocalizer();

	const humanDate = new Date(date).toLocaleDateString(t.language, {
		day: '2-digit',
		month: 'long',
		timeZone: locationTimezone,
	});

	const tMax = temperatureDisplayReduce(historic.max.temperature, temperatureUnit, true);
	const tMin = temperatureDisplayReduce(historic.min.temperature, temperatureUnit, true);

	return (
		<div className={className}>
			<p className={styles.intro}>
				{t('historicTemperature')}
				<br />
				{humanDate}:
			</p>
			<div className={styles.wrapper}>
				<p className={styles.row}>
					{t('max')}: <span className={styles.temperature}>{tMax}</span>{' '}
					<span className={styles.year}>({historic.max.year})</span>
				</p>
				<p className={styles.row}>
					{t('min')}: <span className={styles.temperature}>{tMin}</span>{' '}
					<span className={styles.year}>({historic.min.year})</span>
				</p>
			</div>
		</div>
	);
};

WeatherHistoric.displayName = 'WeatherDailyHistoric';
